import { CompressionRequest, DecompressionRequest } from "../Types/AllTypes";

export const DefaultCompressionRequest: CompressionRequest = {
  tools: [],
  plaintext: "",
}

export const DefaultDecompressionRequest: DecompressionRequest = {
  tools: [],
  ciphertext: "",
  listToCol: null,
}

// DEV MODE
// export const LocalHost = "http://127.0.0.1:8000/compression-playground"

// PROD MODE
export const LocalHost = "https://api.boraakyuz.me/compression-playground"